"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9861],{

/***/ 14900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ accessibility_statement_link_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./static/svg/accessibility/accessibility_icon6.svg
var _path, _circle, _circle2;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgAccessibilityIcon6 = function SvgAccessibilityIcon6(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 21,
        fill: "none",
        viewBox: "0 0 21 21"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.2,
        d: "m6 8 4.035.913v3.155L8.142 17M15.216 8l-4.035.913v3.155L13.074 17"
    })), _circle || (_circle = /*#__PURE__*/ react.createElement("circle", {
        cx: 10.5,
        cy: 10.5,
        r: 9.5,
        stroke: "#000",
        strokeLinecap: "round"
    })), _circle2 || (_circle2 = /*#__PURE__*/ react.createElement("circle", {
        cx: 10.5,
        cy: 5.5,
        r: 1.5,
        stroke: "#000"
    })));
};
/* harmony default export */ var accessibility_icon6 = (SvgAccessibilityIcon6);

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/accessibility/accessibility-statement-link/accessibility-statement-link-component.scss.js


var StyledAccessibilityStatementLinkComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e97kqcm0"
})("display:flex;font-size:0.75rem;cursor:pointer;.accessibility-icon-wrapper{display:flex;.accessibility-icon{circle,path{color:", colors/* default.text-gray */.Z["text-gray"], ";transition:stroke 150ms ease;}}}.accessibility-link-wrapper{padding-left:8px;display:flex;align-items:center;.accessibility-link{transition:150ms color ease;color:", colors/* default.text-gray */.Z["text-gray"], ";}}&:hover{.accessibility-icon-wrapper{.accessibility-icon{path,circle{stroke:", colors/* default.iris */.Z.iris, ";}}}.accessibility-link-wrapper{.accessibility-link{color:", colors/* default.iris */.Z.iris, ";}}}");

;// CONCATENATED MODULE: ./components/accessibility/accessibility-statement-link/accessibility-statement-link-component.js





var AccessibilityStatementLinkComponent = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAccessibilityStatementLinkComponent, {
        className: "accessibilty-statement-link-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "accessibility-icon-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accessibility_icon6, {
                    className: "accessibility-icon"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "accessibility-link-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: links/* ACCESSIBILITY_STATEMENT_LINK */.eY0,
                    className: "accessibility-link",
                    children: props.translate("footer.accessibiltyStatement")
                })
            })
        ]
    });
};
/* harmony default export */ var accessibility_statement_link_component = ((0,generic_config_context/* withGenericConfig */.P)(AccessibilityStatementLinkComponent));


/***/ }),

/***/ 69861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ short_footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./components/core/language-picker/language-picker-component.js + 6 modules
var language_picker_component = __webpack_require__(39160);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/palette-icons-component.js + 3 modules
var palette_icons_component = __webpack_require__(87917);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./components/core/language-picker/language-picker-service.js
var language_picker_service = __webpack_require__(42803);
// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./constants/work-managment-logos.js
var work_managment_logos = __webpack_require__(74329);
;// CONCATENATED MODULE: ./components/core/short-footer/short-footer-service.js



var TITLE_TYPE = {
    MAIN: "MAIN",
    MAIN_CLICKABLE: "MAIN_CLICKABLE",
    SECONDARY: "SECONDARY",
    LINK: "LINK"
};
var PRODUCTS_LINKS = [
    {
        title: "header.products",
        type: TITLE_TYPE.MAIN
    },
    {
        title: "header.tabs.solutions.byProduct.workManagement",
        url: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler,
        icon: work_managment_logos/* default.WM_FOOTER_LOGO */.Z.WM_FOOTER_LOGO,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.products.mondaySalesCRM.newLayout.topic",
        url: links/* CRM_MINI_SITE_LINK */.mgz,
        icon: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/footer/crm_icon_footer.png",
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.products.mondayDev.newLayout.topic",
        url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
        icon: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/footer/dev_new_mobile_footer_logo.png",
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.products.mondayService.newLayout.topic",
        url: links/* SERVICE_MINI_SITE_LINK */.Kon,
        icon: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/service/Service-logo-footer.png",
        type: TITLE_TYPE.LINK,
        hasBetaTag: true
    }
];
var FEATURES_LINKS = [
    {
        title: "footer.features",
        type: TITLE_TYPE.MAIN
    },
    {
        title: "footer.dashboard",
        url: links/* DASHBOARDS_PAGE_LINK */.yCu,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.integrations",
        url: links/* INTEGRATIONS_PAGE_LINK */.oUX,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.automations",
        url: links/* AUTOMATIONS_PAGE_LINK */.cPO,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.product.gantt.title",
        url: links/* GANTT_PAGE_LINK */.TA3,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.kanban",
        url: links/* KANBAN_PAGE_LINK */.ivN,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.workdocs",
        url: links/* WORKDOCS_PAGE_LINK */.RdE,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.ai",
        url: links/* AI_PAGE_LINK */.lro,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.features.keyFeatures.forms.title",
        url: links/* FORMS_PAGE_LINK */.ua2,
        type: TITLE_TYPE.LINK
    }
];
var COMPANY_LINKS = [
    {
        title: "footer.ourTeam",
        type: TITLE_TYPE.MAIN
    },
    {
        title: "footer.aboutUs",
        url: links/* ABOUT_US_PAGE_LINK */.iAZ,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.careers",
        url: links/* CAREERS_PAGE_LINK */.sb2,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.investorRelations",
        url: links/* INVESTOR_RELATIONS_LINK */.ObI,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.partners",
        url: links/* PARTNERS_PAGE_LINK */.MW2,
        type: TITLE_TYPE.LINK
    }
];
var RESOURCES_LINKS = [
    {
        title: "footer.resources",
        type: TITLE_TYPE.MAIN
    },
    {
        title: "footer.blog",
        url: links/* BLOG_PAGE_LINK */.xR0,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.whatsNew",
        url: links/* WHATS_NEW_PAGE_LINK */.Lmq,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.mondaySpaces",
        url: links/* MONDAY_SPACES_PAGE_LINK */.UN3,
        type: TITLE_TYPE.LINK
    }
];
var TEAM_TYPE_LINKS = [
    {
        title: "footer.projectManagement",
        url: links/* WORK_MANAGEMENT_FOR_PMO_MINI_SITE_LINK */.Y42,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.marketing",
        url: links/* WORK_MANAGEMENT_FOR_MARKETING_MINI_SITE_LINK */.qAD,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.salesUseCase",
        url: links/* CRM_MINI_SITE_LINK */.mgz,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.solutions.byTeam.developers.title",
        url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.operations",
        url: links/* OPERATIONS_CLUSTER_LINK */.R9t,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.itOperations",
        url: links/* SERVICE_MINI_SITE_LINK */.Kon,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.hr",
        url: links/* HR_USE_CASES_LINK */.n$n,
        type: TITLE_TYPE.LINK
    }
];
var COMPANY_SIZE_LINKS = [
    {
        title: "header.tabs.solutions.byTeam.companySize",
        type: TITLE_TYPE.MAIN
    },
    {
        title: "footer.enterprise",
        url: links/* ENTERPRISE_PAGE_LINK */.RVF,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.workflows.byBusinessSize.smallBusiness",
        url: links/* SMB_PAGE_LINK */.qDl,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.workflows.byBusinessSize.nonprofit",
        url: links/* NGO_PAGE_LINK */.htU,
        type: TITLE_TYPE.LINK
    }
];
var TEAMS_LINKS = [
    {
        title: "header.teams",
        type: TITLE_TYPE.MAIN
    }
].concat((0,_to_consumable_array/* default */.Z)(TEAM_TYPE_LINKS), (0,_to_consumable_array/* default */.Z)(COMPANY_SIZE_LINKS));
var LINKS_DATA_COLUMNS = (0,_to_consumable_array/* default */.Z)(PRODUCTS_LINKS).concat((0,_to_consumable_array/* default */.Z)(FEATURES_LINKS), (0,_to_consumable_array/* default */.Z)(COMPANY_LINKS), (0,_to_consumable_array/* default */.Z)(RESOURCES_LINKS), (0,_to_consumable_array/* default */.Z)(TEAMS_LINKS), [
    {
        title: "footer.pricing",
        url: links/* PRICING_PAGE_LINK */.C9V,
        type: TITLE_TYPE.MAIN_CLICKABLE
    },
    {
        title: "footer.contactSales",
        isClickable: true,
        url: links/* CONTACT_SALES_FROM_FOOTER_PAGE_LINK */.vMu,
        type: TITLE_TYPE.MAIN_CLICKABLE
    },
    {
        title: "footer.contactUs",
        isClickable: true,
        url: links/* CONTACT_US_PAGE_LINK */.nO,
        type: TITLE_TYPE.MAIN_CLICKABLE
    }
]);

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./components/core/short-footer/short-footer-link/short-footer-link.scss.js



var StyledShortFooterLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "ekk5iqg0"
})("text-decoration:none;cursor:default;width:fit-content;color:", colors/* default.black */.Z.black, ";line-height:12px;display:flex;align-items:center;gap:4px;transition:100ms color ease;.link-icon{height:12px;width:12px;}&.main-title{font-weight:600;font-size:0.875rem;&.clickable{text-decoration:underline;cursor:pointer;}}&.secondary-title{font-weight:600;color:", colors/* default.asphalt */.Z.asphalt, ";font-size:0.75rem;}&.link{font-weight:400;font-size:0.75rem;cursor:pointer;&:hover{color:", colors/* default */.Z[color_consts.IRIS_COLOR_NAME], ";}}.beta-tag{font-size:0.6875rem;font-weight:400;color:", colors/* default */.Z[color_consts.BRAND_SERVICE_PRIMARY_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.LIGHT_BACKGROUND_PINK], ";border-radius:12px;padding:1px 5px;line-height:normal;border-radius:32px;}");

;// CONCATENATED MODULE: ./components/core/short-footer/short-footer-link/short-footer-link.js












var _obj;
var LINK_TYPE_TO_CLASS_NAME = (_obj = {}, (0,_define_property/* default */.Z)(_obj, TITLE_TYPE.MAIN, "main-title"), (0,_define_property/* default */.Z)(_obj, TITLE_TYPE.MAIN_CLICKABLE, "main-title clickable"), (0,_define_property/* default */.Z)(_obj, TITLE_TYPE.SECONDARY, "secondary-title"), (0,_define_property/* default */.Z)(_obj, TITLE_TYPE.LINK, "link"), _obj);
var ShortFooterLink = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ShortFooterLink, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ShortFooterLink);
    function ShortFooterLink(props) {
        (0,_class_call_check/* default */.Z)(this, ShortFooterLink);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(ShortFooterLink, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, url = _props.url, translate = _props.translate, type = _props.type, icon = _props.icon, hasBetaTag = _props.hasBetaTag;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledShortFooterLink, {
                    className: classnames_default()("short-footer-link-component", LINK_TYPE_TO_CLASS_NAME[type]),
                    href: url,
                    children: [
                        icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            className: "link-icon",
                            src: icon,
                            alt: translate(title)
                        }),
                        translate(title),
                        hasBetaTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "beta-tag",
                            children: translate("header.tabs.solutions.byProduct.dev.beta")
                        })
                    ]
                });
            }
        }
    ]);
    return ShortFooterLink;
}(react.PureComponent);
/* harmony default export */ var short_footer_link = ((0,generic_config_context/* withGenericConfig */.P)(ShortFooterLink));

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/short-footer/short-footer.scss.js



var StyledShortFooter = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("footer", {
    target: "e1n3z9yf0"
})("color:", colors/* default.black */.Z.black, ";display:flex;flex-direction:column;align-items:center;padding:48px 80px;justify-content:center;.short-footer-header{width:100%;justify-content:space-between;display:flex;margin-bottom:48px;flex-direction:row;.language-picker-wrapper-component{width:120px;.language-picker-component{.language-picker-dialog-component-wrapper{margin:0;}}}}.short-footer-links{width:100%;column-count:4;flex-wrap:wrap;.link-wrapper{flex-basis:100%;break-inside:avoid;margin:0 0 20px;&.main:not(:first-child){margin-top:28px;}&.main:nth-child(15n),&.main:nth-child(24n),&.main:nth-child(36n){break-before:column;margin-top:0;}}}.bottom{display:flex;flex-direction:column;margin-top:32px;align-items:center;gap:12px;.terms{display:flex;gap:12px;.accessibility-statement-link-wrapper{display:flex;align-items:center;}}.footer-link{display:flex;align-items:center;text-decoration:underline;a{transition:150ms color ease;color:", colors/* default.text-gray */.Z["text-gray"], ";font-size:0.75rem;}}}.monday-logo-wrapper{.footer-monday-logo-image{height:32px;}}.contact-info-wrapper{font-size:0.8125rem;text-align:center;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){align-items:initial;padding:32px;.short-footer-links{column-count:2;flex-wrap:wrap;.link-wrapper{&.main:nth-child(15n),&.main:nth-child(36n){break-before:auto;margin-top:28px;}}}.bottom{align-items:initial;.contact-info-wrapper{text-align:left;width:100%;line-height:24px;.address-info{margin-top:0;}}.social-proof-wrapper{width:100%;.palette-icons-container{margin-top:0;}.icons-wrapper{margin:0 !important;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MIN_WIDTH */.Lk, "){.terms{flex-wrap:wrap;.accessibility-statement-link-wrapper{flex-basis:100%;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, ") and (min-width:", vp_sizes/* MOBILE_QUERY_MIN_WIDTH */.Lk, "){align-items:center;.short-footer-links{column-count:3;flex-wrap:wrap;.link-wrapper{&.main:nth-child(36n){break-before:column;margin-top:0;}}}.bottom{width:100%;align-items:center;justify-content:center;.contact-info-wrapper{text-align:center;}.social-proof-wrapper{display:flex;align-items:center;justify-content:center;.icons-wrapper{width:fit-content;}}}}}");

// EXTERNAL MODULE: ./components/accessibility/accessibility-statement-link/accessibility-statement-link-component.js + 2 modules
var accessibility_statement_link_component = __webpack_require__(14900);
// EXTERNAL MODULE: ./constants/localization.js
var localization = __webpack_require__(72632);
;// CONCATENATED MODULE: ./components/core/short-footer/short-footer.js





function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}















var short_footer_obj;
var TITLE_TYPE_TO_CLASS_NAME = (short_footer_obj = {}, (0,_define_property/* default */.Z)(short_footer_obj, TITLE_TYPE.MAIN, "main"), (0,_define_property/* default */.Z)(short_footer_obj, TITLE_TYPE.MAIN_CLICKABLE, "main standalone"), (0,_define_property/* default */.Z)(short_footer_obj, TITLE_TYPE.SECONDARY, "secondary"), (0,_define_property/* default */.Z)(short_footer_obj, TITLE_TYPE.LINK, "item"), short_footer_obj);
var ShortFooter = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ShortFooter, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ShortFooter);
    function ShortFooter(props) {
        (0,_class_call_check/* default */.Z)(this, ShortFooter);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(ShortFooter, [
        {
            key: "renderLinks",
            value: function renderLinks() {
                var _props = this.props, localeId = _props.localeId, pageClusterConfig = _props.pageClusterConfig, useProductMiniSiteConfig = _props.useProductMiniSiteConfig;
                var links = LINKS_DATA_COLUMNS;
                if (pageClusterConfig) {
                    (0,cluster_config_service/* updateClusterShortFooterLinks */.j8)(pageClusterConfig, links, {
                        useProductMiniSiteConfig: useProductMiniSiteConfig
                    });
                }
                return links.map(function(link) {
                    var title = link.title, type = link.type;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("short-footer-link-component-wrapper", "link-wrapper", (0,_define_property/* default */.Z)({}, TITLE_TYPE_TO_CLASS_NAME[type], type)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer_link, _object_spread({
                            localeId: localeId
                        }, link))
                    }, title);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, translate = _props.translate, localeId = _props.localeId;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledShortFooter, {
                    className: "short-footer-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "short-footer-header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "monday-logo-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, {
                                        src: links/* MONDAY_LOGO_SRC */.Onk,
                                        className: "footer-monday-logo-image",
                                        href: links/* ROOT_LINK */.yjY,
                                        alt: "monday logo"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "language-picker-wrapper-component link-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(language_picker_component/* default */.Z, {
                                        dialogDirection: language_picker_service/* DIALOG_DIRECTIONS.ALIGN_BOTTOM */.Df.ALIGN_BOTTOM
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "short-footer-links",
                            children: this.renderLinks()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bottom",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "contact-info-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "all-right-reserved-info",
                                        children: [
                                            translate("allRightsReserved"),
                                            " \xa9 monday.com"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "social-proof-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(palette_icons_component/* default */.Z, {
                                        SocialFooterLinks: links/* SocialFooterLinks */.Ff7
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "terms",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "accessibility-statement-link-wrapper link-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accessibility_statement_link_component/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "footer-link",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: links/* PRIVACY_POLICY_LINK */.jbE,
                                                children: translate("footer.termsAndPrivacy")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "footer-link",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                "data-footer-link-type": "cookie-settings",
                                                onClick: function() {
                                                    var _window_cookiehub, _window;
                                                    return (_window = window) === null || _window === void 0 ? void 0 : (_window_cookiehub = _window.cookiehub) === null || _window_cookiehub === void 0 ? void 0 : _window_cookiehub.openSettings();
                                                },
                                                children: translate("footer.yourPrivacyChoices")
                                            })
                                        }),
                                        localeId === localization.GERMAN_LOCALE_ID && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "footer-link",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: links/* IMPRESSUM_LINK */.YSM,
                                                children: translate("footer.impressum")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return ShortFooter;
}(react.PureComponent);
/* harmony default export */ var short_footer = ((0,generic_config_context/* withGenericConfig */.P)(ShortFooter));


/***/ }),

/***/ 87917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PaletteIconsComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/palette-icons-component.scss.js


var StyledSinglePaletteIconComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ktd0x80"
})("display:flex;.icons-wrapper{display:flex;justify-content:space-between;align-items:center;gap:16px;}.single-app-icon-wrapper{margin-right:8px;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){margin:0 auto;padding:0;flex-wrap:wrap;margin-top:16px;.icons-wrapper:first-child{margin-right:auto;}.icons-wrapper{width:200px;margin:0 auto;margin-bottom:8px;}}");

// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/single-palette-icon/single-palette-icon-component.scss.js



var single_palette_icon_component_scss_StyledSinglePaletteIconComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e76zi3x0"
})("svg{height:24px;width:auto;}&:hover{svg{path{fill:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/single-palette-icon/single-palette-icon-component.js







var SinglePaletteIconComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SinglePaletteIconComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SinglePaletteIconComponent);
    function SinglePaletteIconComponent() {
        (0,_class_call_check/* default */.Z)(this, SinglePaletteIconComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SinglePaletteIconComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, clickableLink = _props.clickableLink, IconComp = _props.IconComp, title = _props.title;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(single_palette_icon_component_scss_StyledSinglePaletteIconComponent, {
                    className: "social-media-icon",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        href: clickableLink,
                        title: title,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "regular-icon-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconComp, {})
                        })
                    })
                }, clickableLink);
            }
        }
    ]);
    return SinglePaletteIconComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/palette-icons-component.js








var PaletteIconsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PaletteIconsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PaletteIconsComponent);
    function PaletteIconsComponent() {
        (0,_class_call_check/* default */.Z)(this, PaletteIconsComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(PaletteIconsComponent, [
        {
            key: "renderSocialMediaIcons",
            value: function renderSocialMediaIcons() {
                var SocialFooterLinks = this.props.SocialFooterLinks;
                var socialMediasIcons = SocialFooterLinks.links;
                return Object.keys(socialMediasIcons).map(function(key) {
                    var socialMediaIcon = socialMediasIcons[key];
                    var IconComp = socialMediaIcon.iconV2;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "single-social-icon-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SinglePaletteIconComponent, {
                            IconComp: IconComp,
                            clickableLink: socialMediaIcon.url,
                            title: socialMediaIcon.title
                        })
                    }, key);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSinglePaletteIconComponent, {
                    className: "palette-icons-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "icons-wrapper",
                        children: this.renderSocialMediaIcons()
                    })
                });
            }
        }
    ]);
    return PaletteIconsComponent;
}(react.PureComponent);



/***/ })

}]);